// extracted by mini-css-extract-plugin
module.exports = {"container":"EventsAndNews_container__Bp01F"};